import React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { translate } from 'utils/translateUtils';
import Link from './components/Link';
import SocialButtons from '../socialButtons/SocialButtons';
import FooterInfo from './components/Info';

import './index.scss';

import mobileImg from './static/img/mobile.svg';
import { externalUrl } from '../../consts/urls';

const enhance = compose(translate);

const b = b_.with('footer-page');

class Footer extends React.Component {
  static propTypes = {
    big: PropTypes.bool
  };

  render() {
    const { t, big } = this.props;

    return (
      <footer className={b({ big: big })}>
        <div className={b('wrapper')}>
          <div className={b('row')}>
            <div className={b('contacts')}>
              <a
                href="https://t.me/ut_personal_manager_bot"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Contact via Telegram')}
              </a>
              <a href="https://wa.me/79959221420" target="_blank" rel="noopener noreferrer">
                {t('Contact via WhatsApp')}
              </a>
              <Link to="mailto:welcome@unitedtraders.com">welcome@unitedtraders.com</Link>
            </div>
            <div className={b('navigation')}>
              <Link to="/investments" needReload newTab>
                {t('Investments')}
              </Link>
              <Link to={externalUrl.utexPartners} newTab>
                {t('Partnership')}
              </Link>
              <Link to="/trading/analytics">{t('Trading')}</Link>
              <Link to="/contacts" needReload>
                {t('Contacts')}
              </Link>
            </div>
            <div className={b('socials')}>
              <SocialButtons type="footer" />
            </div>
            <div className={b('info')}>
              <FooterInfo />
            </div>
          </div>
          <div className={b('row')}>
            <button className={b('mobile-version-btn')} onClick={this.goToMobileVersion}>
              <img src={mobileImg} alt="" />
              {t('Mobile version')}
            </button>
          </div>
        </div>
      </footer>
    );
  }

  goToMobileVersion() {
    if (typeof window === 'undefined') {
      return;
    }
    Cookies.set('preferred_platform', 'mobile', { path: '/' });
    window.location.reload();
  }
}

export default enhance(Footer);



// WEBPACK FOOTER //
// ./src/blocks/footer/index.js